import WebFont from 'webfontloader';
import FontFaceObserver from 'fontfaceobserver';

import allFonts from '../resources/fonts';

const loadFontCssFiles = fonts => {
  return new Promise((resolve, reject) => {
    if (fonts.length === 0) resolve();
    WebFont.load({
      google: {
        families: fonts
      },
      active() {
        resolve();
      },
      inactive() {
        reject();
      }
    });
  });
};

/*
  The way Google Fonts structures it's CSS files and font files, fonts subsets such as arabic characters don't automatically get downloaded
  via `webfontloader`. The font file containing subset characters will only get loaded once the DOM contains a character within that 
  subsets `unicode-range`. `fontfaceobserver` does a better job of loading the font file as you can provide it a test string - so we can build
  a test string from the text in the scribe to ensure that all the fonts needed to render the text in a scribe are preloaded.
*/
const loadFontsFiles = testStringDict => {
  return Promise.all(
    Object.entries(testStringDict).map(([font, testStr]) => {
      const obs = new FontFaceObserver(font);
      return obs.load(testStr);
    })
  );
};

const loadFonts = async testStringDict => {
  await loadFontCssFiles(Object.keys(testStringDict));
  await loadFontsFiles(testStringDict);
};

async function preloadElementFonts(elements) {
  const testStringDict = elements.reduce((dict, element) => {
    const font = element.font.value;
    const str = element.text;
    return {
      ...dict,
      [font]: (dict[font] || '') + str
    };
  }, {});

  await loadFonts(testStringDict);
}

export async function preloadAllScribesFonts(scribes) {
  const textElements = scribes.flatMap(scribe => scribe.elements).filter(el => el.type === 'Text');
  try {
    await preloadElementFonts(textElements);
  } catch (e) {
    console.error(e);
  }
}

export default async function preloadScribeFonts(scribe) {
  await preloadAllScribesFonts([scribe]);
}

export async function loadAllSelectableFonts(scribeText) {
  const familiesDict = allFonts.reduce((dict, font) => ({ ...dict, [font.value]: scribeText || font.value }), {});
  try {
    await loadFonts(familiesDict);
  } catch (e) {
    console.error(e);
  }
}
